module.exports = __webpack_public_path__ + "static/sinteritPRO-335a09970f8b2355685f42d02eae16c2.png";